import classnames from 'classnames';
import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';

import { Icon } from '@eb/eds-icon';
import { ICON_TYPE_PROP_TYPE } from '@eb/eds-icon';
import * as ORBIT from '../../constants/orbit';

import { LogoEColorBrand } from '@eb/eds-iconography';
import { LogoEBrand } from '@eb/eds-iconography';

export const Star = ({ name, location, iconType }) => {
    const classNames = classnames({
        'eds-align--center orbit__sun': location === ORBIT.CENTER,
        'orbit__star--rotate-inner': location === ORBIT.INNER,
        'orbit__star--rotate-outer': location === ORBIT.OUTER,
        [`orbit__star orbit__star-${name}`]: location !== ORBIT.CENTER,
    });

    let iconShown = <Icon type={iconType} width="100%" height="100%" />;

    if (iconType.type.displayName === LogoEColorBrand.displayName) {
        iconShown = (
            <Icon
                type={<LogoEBrand />}
                color="white"
                width="50%"
                height="50%"
            />
        );
    }

    return (
        <div className={classNames} data-spec="orbit-star">
            {iconShown}
        </div>
    );
};

export default class Orbit extends PureComponent {
    static propTypes = {
        stars: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
                location: PropTypes.oneOf([
                    ORBIT.INNER,
                    ORBIT.OUTER,
                    ORBIT.CENTER,
                ]),
                iconType: ICON_TYPE_PROP_TYPE,
            }),
        ),
    };

    render() {
        const { stars } = this.props;

        const starItems = stars.map(({ name, location, iconType }) => (
            <Star
                key={name}
                name={name}
                location={location}
                iconType={iconType}
            />
        ));

        return (
            <div className="orbit eds-g-cell eds-g-cell-12-12 eds-g-cell-sw-7-12 eds-g-offset-sw-1-12 eds-g-cell--has-overflow eds-l-sn-mar-bot-2 eds-l-sm-mar-bot-2">
                <div className="orbit__ring orbit__ring--inner" />
                <div className="orbit__ring orbit__ring--outer" />
                <div className="orbit__ring orbit__ring--external eds-hide-sn" />
                {starItems}
            </div>
        );
    }
}
